/** The word that agrees with the count: `agree(1, "is", "are")` is "is". */
export function agree(count: number, one: string, many: string): string {
  return count === 1 ? one : many;
}

/** "1 element", "2 elements": the count and the noun that agrees with it. */
export function plural(count: number, noun: string): string {
  return `${String(count)} ${noun}${count === 1 ? "" : "s"}`;
}

const LIST = new Intl.ListFormat("en", { style: "long", type: "conjunction" });

/** "a", "a and b", "a, b, and c": the items read as one English list. */
export function listed(items: readonly string[]): string {
  return LIST.format(items);
}
